/**
 * WABA (cuenta de WhatsApp Business) de una plantilla.
 *
 * Las plantillas anteriores a guardar la WABA la traen vacía: se crearon en la del WhatsApp por
 * defecto, así que cuentan como suyas. Es la misma regla que aplica el backend al elegir plantilla.
 *
 * @param {object} template - TemplateDto o plantilla cruda del API
 * @param {string|null} defaultBusinessAccountId - WABA del canal de WhatsApp por defecto
 * @returns {string|null}
 */
export const templateBusinessAccountId = (template, defaultBusinessAccountId) =>
    template?.businessAccountId || template?.business_account_id || defaultBusinessAccountId || null;

/**
 * ¿La plantilla es de esa WABA? Sin WABA elegida (una sola línea) todas lo son.
 */
export const isTemplateInBusinessAccount = (template, businessAccountId, defaultBusinessAccountId) =>
    !businessAccountId || templateBusinessAccountId(template, defaultBusinessAccountId) === businessAccountId;
